import { forwardRef } from 'react'
import type { ButtonHTMLAttributes } from 'react'
import { cn } from '../../lib/cn'

type Variant = 'black' | 'glass-dark' | 'glass-light'

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  'aria-label': string
}

const variants: Record<Variant, string> = {
  black:
    'bg-[#2183d8] text-white hover:bg-[#1c72bd] focus-visible:outline-[#2183d8]',
  'glass-dark':
    'bg-black/[0.04] text-black hover:bg-black/[0.08] focus-visible:outline-black',
  'glass-light':
    'bg-white/[0.16] text-white hover:bg-white/[0.24] focus-visible:outline-white',
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  function IconButton({ className, variant = 'glass-dark', children, ...props }, ref) {
    return (
      <button
        ref={ref}
        className={cn(
          'inline-flex items-center justify-center size-10 rounded-full transition-colors disabled:opacity-40 focus:outline-none',
          variants[variant],
          className,
        )}
        {...props}
      >
        {children}
      </button>
    )
  },
)
